<template>
    <div class="editor" :class="isMoment?'advEditor':'editor'">
            <ckeditor :editor="editor" v-model="content" :config="editorConfig" @ready="onReady"
                      @blur="onEditorBlur"></ckeditor>
    </div>

</template>

<script>

  import uiVariable from "../../config/uiVariable";
  import { lang } from "../../locale";
  import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
  import MyUploadAdapter from "./uploadAdapter";

  export default {
    name: "K2Editor",
    props: ["passContent", "input", "passIsMoment"],
    data() {
      return {
        uiVariable: uiVariable,
        content: "",
        editor: DecoupledEditor,
        editorConfig: {
          extraPlugins: [this.uploader],
          toolbar: ["alignment", "bold", "italic", "underline", "link", "bulletedList", "numberedList", '|', "insertTable", "uploadImage"]
        },
        isMoment: false
      };
    },
    watch: {
      passContent: function(value) {
        if (value) {
          this.content = value;
        }
      },
      passIsMoment: function(value) {
        if (value) {
          this.isMoment = value;
        }else{
          this.isMoment = false;
        }
      }
    },
    components: {},
    mounted() {
      if (this.passContent) {
        this.content = this.passContent;
      }
    },
    methods: {
      lang,
      onReady(editor) {
        editor.ui.getEditableElement().parentElement.insertBefore(
          editor.ui.view.toolbar.element,
          editor.ui.getEditableElement()
        );
      },
      onEditorBlur() {
        console.log(this.content,"onEditorBlur")
        this.$emit("input", this.content);
      },
      uploader(editor) {
        editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
          return new MyUploadAdapter(loader);
        };
      }
      //todo:quill editor upload image to server backup (jess)
      // handleEditorImage() {
      //   const input = document.createElement("input");
      //   input.setAttribute("type", "file");
      //   input.click();
      //   // Listen upload local image and save to server
      //   input.onchange = (event) => {
      //     const file = input.files[0];
      //     let blobUrl = URL.createObjectURL(input.files[0]);
      //     file.url = blobUrl;
      //     console.log("handleEditorImage", file);
      //
      //     // file type is only image.
      //     if (/^image\//.test(file.type)) {
      //       this.saveToServer(file);
      //     } else {
      //       console.warn("You could only upload images.");
      //     }
      //   };
      // },
      // async saveToServer(file) {
      //   try {
      //     const response = await DataSource.shared.getEditorUploadURL(file);
      //     if (response) {
      //       this.insertToEditor(response.file0);
      //     }
      //   } catch (e) {
      //     console.log(e, "save to server error");
      //   }
      // },
      // insertToEditor(url) {
      //   const range = this.snow.getSelection();
      //   console.log(range, "range1");
      //
      //   // const { quill } = this.$refs.postContentEditor;
      //   // console.log(quill,"quill")
      //   // const range = quill.getSelection();
      //   this.snow.insertEmbed(range.index, "image", `${url}`);
      // }
    }
  };
</script>

<style>
    .editor u {
        text-decoration: underline;
    }
</style>